import { Box, TableContainer, Table, TableRow, TableBody, TableCell, Card } from '@mui/material'
import LoadingWrapper from 'components/LoadingWrapper'
import { useRootLoaderData } from 'components/Root.loader'
import { AUTHORITIES_JP } from 'config'

function AccountSettings() {
  const rootData = useRootLoaderData()
  const userProfile = rootData.profile
  const userGroupConfig = rootData.userGroupConfig

  const { email, name, subGroups, authority } = userProfile

  const rows = [
    ['ログインアドレス', email],
    ['利用者名', name],
    ['権限', AUTHORITIES_JP[authority]],
    ['所属グループ', subGroups.map((group) => <div key={group}>{group}</div>)],
    ['Concur連携', userGroupConfig.useConcur ? '連携あり' : null],
  ].filter(([, val]) => val)

  return (
    <Box sx={{ maxWidth: 768 }}>
      <h1>アカウント設定</h1>

      <LoadingWrapper loaded={Boolean(rootData)}>
        <h2>アカウント情報</h2>
        <Card variant="outlined">
          <TableContainer>
            <Table style={{ tableLayout: 'fixed' }}>
              <TableBody>
                {rows.map(([label, value]) => (
                  <TableRow key={label as string}>
                    <TableCell component="th" variant="head">
                      {label}
                    </TableCell>
                    <TableCell>{value}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Card>
      </LoadingWrapper>
    </Box>
  )
}

export default AccountSettings
